import React from 'react';
import { Collapse } from 'react-bootstrap';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import PropTypes from 'prop-types';
import './tableCollapse.scss';

function TableCollapse({ isOpen, toggle, id, title, children }) {
    return (
        <>
            <button
                onClick={() => toggle(id)}
                className={`sub-heading ${isOpen ? '' : ' collapsed'}`}
                aria-controls={`${id}-collapse-content`}
                aria-expanded={isOpen}
                type="button"
            >
                {isOpen ? <ChevronDown /> : <ChevronUp />}
                {title}
                {isOpen ? <ChevronDown /> : <ChevronUp />}
            </button>
            <Collapse in={isOpen}>
                <div id={`${id}-collapse-content`}>{children}</div>
            </Collapse>
        </>
    );
}

TableCollapse.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    children: PropTypes.node.isRequired
};

export default TableCollapse;
